import $ from 'jquery';
import Chartist from 'chartist';
import 'chartist-plugin-legend';

const optionsWithLegend = legend => ({
  height: 250,
  width: 1200,
  fullWidth: true,
  low: 0,
  lineSmooth: false,
  showArea: true,
  chartPadding: {
    right: 30,
    left: 10,
    top: 20,
    bottom: 5,
  },
  axisY: {
    onlyInteger: true,
    offset: 30,
    labelOffset: {
      y: 5,
    },
  },
  axisX: {
    labelOffset: {
      x: -15,
      y: 5,
    },
  },
  plugins: [
    Chartist.plugins.legend({
      legendNames: [legend],
    }),
  ],
});

export const list = () => {
  consumptionsPlot();
  capturesPlot();
};

function consumptionsPlot() {
  const $consumptions = $('.plots .conso .data');
  $consumptions.each((index, element) =>
    plotFromSelector(
      element,
      '#' +
        $(element)
          .parent()
          .attr('id'),
      'Consommation (%)'
    )
  );
}

function capturesPlot() {
  const $captures = $('.plots .capture .data');
  $captures.each((index, element) =>
    plotFromSelector(
      element,
      '#' +
        $(element)
          .parent()
          .attr('id'),
      'Captures'
    )
  );
}

function plotFromSelector(element, name, legend) {
  const $selector = $(element);
  const labels = $selector.attr('data-labels').split(',');
  const values = $selector
    .attr('data-values')
    .split(',')
    .map(v => Number(v));

  if (labels.length && values.length) {
    Chartist.Line(
      name,
      {
        labels: labels,
        series: [values],
      },
      optionsWithLegend(legend)
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/plots/index.js